module.exports = __webpack_public_path__ + "img/12-1.43973cf2.jpg";